module.exports = __webpack_public_path__ + "static/media/download-icon.3e546244.svg";